// import './App.css';
import Fade from "../../components/Fade";
import LogoFooter from "../../components/LogoFooter";
import { useNavigate } from "react-router-dom";
// import { invoke } from "@tauri-apps/api"

function App() {
  const navigate = useNavigate();

  const handleNavigateToAtendimento = (e) => {
    e.stopPropagation();
    navigate("/atendimento");
  };

  const handleNavigateToPesquisa = () => {
    navigate("/servico");
  };

  const handleNavigateToConquistas = () => {
    navigate("/conquistas");
  };

  const handleNavigateToVideoInstitucional = () => {
    navigate("/video-institucional");
  };

  const localTotem = process.env.REACT_APP_LOCAL_TOTEM;
  const isSede = localTotem !== "sede";
  const sedeButtonsConfig = (
    process.env.REACT_APP_HOME_BUTTONS_SEDE || "servicos,conquistas,video"
  )
    .split(",")
    .map((item) => item.trim().toLowerCase())
    .filter(Boolean);
  const sedeButtonOrder = ["conquistas", "servicos", "video"];

  const allButtons = {
    pesquisa: {
      key: "pesquisa",
      label: "Pesquisa de Satisfação",
      onClick: handleNavigateToPesquisa,
      className:
        "bg-deepBlue shadow-lg min-w-[300px] text-4xl px-8 py-4 rounded-2xl text-white hover:brightness-95 font-tommy font-bold w-72 leading-snug transition",
    },
    conquistas: {
      key: "conquistas",
      label: "Conquistas da gestão",
      onClick: handleNavigateToConquistas,
      className:
        "bg-deepBlue shadow-lg min-w-[300px] text-4xl px-8 py-4 rounded-2xl text-white hover:brightness-95 font-tommy font-bold w-72 leading-snug transition",
    },
    servicos: {
      key: "servicos",
      label: "Serviços",
      onClick: handleNavigateToAtendimento,
      className:
        "bg-deepBlue shadow-lg min-w-[300px] text-4xl px-8 py-4 rounded-2xl text-white hover:brightness-95 font-tommy font-bold w-56 transition",
    },
    video: {
      key: "video",
      label: "Vídeo institucional",
      onClick: handleNavigateToVideoInstitucional,
      className:
        "bg-deepBlue shadow-lg min-w-[300px] text-4xl px-8 py-4 rounded-2xl text-white hover:brightness-95 font-tommy font-bold w-72 leading-snug transition",
    },
  };

  const buttonsToRender = isSede
    ? sedeButtonOrder
        .filter((buttonKey) => sedeButtonsConfig.includes(buttonKey))
        .map((buttonKey) => allButtons[buttonKey])
    : [allButtons.pesquisa, allButtons.servicos];

  return (
    <>
      <Fade>
        {/* <DelayedLinkWithFadeout to="atendimento" className="flex-1 flex flex-col"> */}
        <div className="mx-auto grid items-center justify-center h-full flex-1">
          <div className="my-2 flex flex-col items-center">
            <h1 className="text-8xl text-center font-tommy px-20">
              <strong className="text-deepBlue">
                Secretaria do Verde <br></br>e Meio Ambiente
              </strong>
            </h1>

            <h2 className="text-deepBlue font-tommy text-6xl font-semibold pt-10">
              Seja bem-vindo(a)!
            </h2>

            <div className="flex space-x-6 justify-center mt-16">
              {buttonsToRender.map((button) => (
                <button
                  key={button.key}
                  onClick={button.onClick}
                  className={button.className}
                >
                  {button.label}
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* </DelayedLinkWithFadeout> */}
      </Fade>
      <div className="w-full h-auto p-6">
        <LogoFooter variant="white" />
      </div>
    </>
  );
}

export default App;
